export const EnumUploadType = {
    image: "image",
    video: "video"
};
export const EnumCrosswordSeriesType = {
    top: "top",
    trending: "trending",
    related: "related",
    editor_picks: "editor_picks",
    home_page: "home_page",
    challenge: "challenge",
    other: "other"
};
export const EnumShowSeriesType = {
    top: "top",
    trending: "trending",
    related: "related",
    editor_picks: "editor_picks",
    home_page: "home_page",
    movie_page: "movie_page",
    tv_page: "tv_page",
    other: "other"
};
export const EnumPermissionRole = {
    ADMIN: "ADMIN",
    ROOT_ADMIN: "ROOT_ADMIN",
    CROSSWORD_READ: "CROSSWORD_READ",
    CROSSWORD_WRITE: "CROSSWORD_WRITE",
    USER_READ: "USER_READ",
    USER_WRITE: "USER_WRITE",
    SHOW_READ: "SHOW_READ",
    SHOW_WRITE: "SHOW_WRITE",
    UPLOAD_READ: "UPLOAD_READ",
    UPLOAD_WRITE: "UPLOAD_WRITE",
    CONSOLE_ACCESS: "CONSOLE_ACCESS",
    PURCHASE_READ: "PURCHASE_READ",
    PURCHASE_WRITE: "PURCHASE_WRITE",
    CREDIT_VOUCHER_READ: "CREDIT_VOUCHER_READ",
    CREDIT_VOUCHER_WRITE: "CREDIT_VOUCHER_WRITE"
};
export const EnumCrosswordCategoryType = {
    intellectual: "intellectual",
    swahili: "swahili",
    general: "general",
    hard: "hard"
};
export const EnumDomainEnvDb = {
    pendwa_org: "pendwa_org",
    pendwa_app: "pendwa_app",
    africacrosswords_com: "africacrosswords_com",
    swiftcomment_com: "swiftcomment_com"
};
export const EnumSCPlatformDb = {
    instagram: "instagram"
};
//# sourceMappingURL=types-enums.js.map